/**
 * Resolve the active organisation from URL, persistence, and the user's client list.
 * Unknown `cid` values must never be treated as a valid org (avoids switch/reload loops).
 */

export function isClientInList(clientId, clients = []) {
  const id = String(clientId || '');
  if (!id) return false;
  const list = Array.isArray(clients) ? clients : [];
  return list.some((client) => String(client?._id) === id);
}

export function getInitialClientId(clients = [], currentRoute = {}, persistedClientId = '') {
  const clientList = Array.isArray(clients) ? clients : [];
  const routeClientId = currentRoute?.query?.cid || '';

  if (routeClientId && isClientInList(routeClientId, clientList)) {
    return String(routeClientId);
  }

  if (persistedClientId && isClientInList(persistedClientId, clientList)) {
    return String(persistedClientId);
  }

  const firstId = clientList[0]?._id;
  return firstId ? String(firstId) : '';
}

/**
 * Best-guess org id before the profile client list is available.
 * Used so profile/getdetails is scoped to the switched tenant on cold reload.
 */
export function getTentativeClientId({
  preferClientId = '',
  routeClientId = '',
  storeClientId = '',
  persistedClientId = '',
} = {}) {
  const candidates = [preferClientId, routeClientId, storeClientId, persistedClientId];
  for (const value of candidates) {
    const id = String(value || '');
    if (id) return id;
  }
  return '';
}

export function hrefMatchesCurrent(resolvedHref, currentLocation = {}) {
  const href = String(resolvedHref || '');
  if (!href) return false;
  const origin = currentLocation.origin || 'http://localhost';
  const pathname = currentLocation.pathname || '';
  const search = currentLocation.search || '';
  const hash = currentLocation.hash || '';
  try {
    const next = new URL(href, origin);
    const cur = new URL(`${pathname}${search}${hash}`, origin);
    return next.pathname === cur.pathname
      && next.search === cur.search
      && next.hash === cur.hash;
  } catch (_) {
    return href === `${pathname}${search}${hash}`;
  }
}

export function normalizeRoutePath(path) {
  return String(path || '').replace(/\/+$/, '') || '/';
}
